// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
Case Usage Example:
h1 { @include font-roboto(400); }
**/
h1 {
  font-size: 2rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h1 {
    font-size: 1.5rem;
  }
}

h2 {
  font-size: 1.8rem;
  margin: 5px 0;
}
@media (max-width: 768px) {
  h2 {
    font-size: 1.2rem;
  }
}

.edit-profile-container {
  width: 100%;
  background-color: #f8f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  padding: 0 50px 50px 50px;
}
.edit-profile-container h1 {
  margin: 25px 0;
}
.edit-profile-container .edit-profile-wrapper {
  width: 100%;
  background-color: #f8f7f7;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 25px;
}
.edit-profile-container .edit-profile-wrapper .edit-profile-options {
  width: 80vw;
  margin-bottom: 25px;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section {
  width: 60vw;
  display: flex;
  box-sizing: border-box;
  background-color: white;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding: 20px;
  gap: 15px;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .radio-buttons-wrapper {
  justify-content: flex-end;
  display: flex;
  gap: 25px;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .radio-buttons-wrapper label {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .radio-buttons-wrapper span {
  margin-left: 35px;
  color: #aa004f;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .radio-buttons-wrapper input[type=radio] {
  visibility: hidden;
  position: absolute;
  cursor: pointer;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .radio-buttons-wrapper input[type=radio]:before {
  display: inline-block;
  content: " ";
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #aa004f;
  visibility: initial;
  margin-top: -5px;
  box-sizing: border-box;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .radio-buttons-wrapper input[type=radio]:checked:before {
  border: 7px solid #CB186B;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .work-doc-download-btn {
  border: 1px solid #baad9e;
  border-radius: 3px;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .work-doc-download-btn .work-doc-upload {
  width: 40%;
  word-break: break-all;
  color: #aa004f;
  text-decoration: none;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input label {
  width: 70%;
  margin-right: 10px;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input input {
  width: 100%;
  padding: 10px;
  display: inline-block;
  border: 1px solid #aa004f;
  border-radius: 4px;
  box-sizing: border-box;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input input:focus {
  border: 2px solid #4d90fe;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input textarea {
  width: 100%;
  padding: 10px;
  display: inline-block;
  border: 1px solid #aa004f;
  border-radius: 4px;
  box-sizing: border-box;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input textarea:focus {
  border: 2px solid #4d90fe;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input input[type=date]::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input input[type=datetime-local]::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input input[type=time]::-webkit-calendar-picker-indicator {
  cursor: pointer;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input select {
  width: 100%;
  padding: 10px;
  display: inline-block;
  border: 1px solid #aa004f;
  border-radius: 4px;
  box-sizing: border-box;
}
.edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .basic-multi-select {
  width: 100%;
  border: 1px solid #aa004f;
  border-radius: 4px;
  box-sizing: border-box;
}
.edit-profile-container .edit-profile-wrapper .edit-services-wrap {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.edit-profile-container .edit-profile-wrapper .file-info-input {
  width: 80%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.edit-profile-container .edit-profile-wrapper .file-info-input label {
  width: 70%;
  margin-right: 10px;
}
.edit-profile-container .edit-profile-wrapper .file-info-input .file-info-view-wrap {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
}
.edit-profile-container .edit-profile-wrapper .file-info-input .file-info-view-wrap input {
  width: 100%;
}
.edit-profile-container .edit-profile-wrapper .file-info-input .file-info-view-wrap .work-doc-download-btn {
  border: 1px solid #baad9e;
  border-radius: 3px;
}
.edit-profile-container .edit-profile-wrapper .file-info-input .file-info-view-wrap .work-doc-download-btn .work-doc-upload {
  width: 40%;
  word-break: break-all;
  color: #aa004f;
  text-decoration: none;
}
.edit-profile-container .edit-profile-wrapper .other-info-section {
  width: 60vw;
  display: flex;
  box-sizing: border-box;
  background-color: white;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper {
  width: 100%;
  display: inline-flex;
  align-items: center;
  position: relative;
  padding: 20px;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .input-section-label {
  width: -webkit-fill-available;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper input[type=text],
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper input[type=number] {
  width: -webkit-fill-available;
  height: 50px;
  background-color: #f8f7f7;
  border: 1px solid #d6d6d6;
  box-sizing: border-box;
  padding: 15px;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper {
  width: -webkit-fill-available;
  justify-content: flex-end;
  display: flex;
  gap: 25px;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper label {
  cursor: pointer;
  display: flex;
  align-items: center;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper span {
  margin-left: 35px;
  color: #aa004f;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper input[type=radio] {
  visibility: hidden;
  position: absolute;
  cursor: pointer;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper input[type=radio]:before {
  display: inline-block;
  content: " ";
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 2px solid #aa004f;
  visibility: initial;
  margin-top: -5px;
  box-sizing: border-box;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper input[type=radio]:checked:before {
  border: 7px solid #CB186B;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .select-wrapper {
  width: -webkit-fill-available;
  justify-content: space-between;
  display: flex;
  gap: 5px;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .select-wrapper select {
  height: 50px;
  background-color: #f8f7f7;
  border: 1px solid #d6d6d6;
  box-sizing: border-box;
  padding: 10px;
  cursor: pointer;
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .dates-wrapper {
  width: -webkit-fill-available;
  justify-content: space-between;
  display: flex;
  gap: 5px;
  width: calc(100% - 15px);
}
.edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .dates-wrapper input {
  width: 33%;
}
.edit-profile-container .avatar-label-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.edit-profile-container .avatar-label {
  display: flex;
  flex-direction: row;
  width: 150px !important;
  height: 150px !important;
  border: 1px solid #CB186B;
  border-radius: 50%;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  float: right;
  cursor: pointer;
  margin-right: 0 !important;
}
.edit-profile-container .avatar-label:hover {
  opacity: 0.8;
}
.edit-profile-container .btn {
  font-size: 0.8rem;
  background: #CB186B;
  padding: 5px 10px;
  border-radius: 15px;
  color: white;
  margin-top: 10px;
  margin-right: 0 !important;
  width: 100% !important;
  display: flex;
  justify-content: center;
  gap: 5px;
  cursor: pointer;
}

@media (max-width: 992px) {
  .edit-profile-container {
    flex-direction: column;
    padding: 0 20px 50px 20px;
  }
  .edit-profile-container .edit-profile-wrapper .edit-profile-options {
    margin-bottom: 25px;
  }
  .edit-profile-container .edit-profile-wrapper .profile-info-input {
    width: 100% !important;
  }
  .edit-profile-container .edit-profile-wrapper .profile-info-section {
    width: 100% !important;
  }
}
.loader {
  margin: auto;
  border: 20px solid #eaf0f6;
  border-radius: 50%;
  border-top: 20px solid #aa004f;
  width: 100px;
  height: 100px;
  animation: spinner 4s linear infinite;
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.button-wrap {
  width: 60vw;
  display: flex;
  margin-bottom: 25px;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 30px 0 0 0;
}

.submit-button {
  align-self: center;
  margin: 5px 0;
}

.error-message {
  color: #aa004f;
  position: absolute;
  top: 40px;
  right: 0;
  font-size: 14px;
}
@media (max-width: 576px) {
  .error-message {
    top: 80px;
  }
}

.toggleBtn {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border: none;
  color: #aa004f;
  font-size: 16px;
  cursor: pointer;
}

@media (max-width: 768px) {
  .edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input {
    flex-direction: column;
    align-items: flex-start;
  }
  .edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input .avatar-label-wrapper {
    width: 100%;
  }
  .edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input p {
    text-align: center;
    width: 100%;
  }
  .edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input label {
    margin-bottom: 10px;
  }
}
@media (max-width: 576px) {
  .edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper {
    flex-direction: column;
  }
  .edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper {
    justify-content: flex-start;
    margin-top: 10px;
  }
  .edit-profile-container .edit-profile-wrapper .profile-info-section {
    width: 90vw;
  }
  .edit-services-wrap {
    flex-direction: row;
  }
  .button-wrap {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/css/fonts.scss","webpack://./src/pages/Profile/CaregiverProfile/EditCaregiverProfile/styles.scss","webpack://./src/css/colors.scss"],"names":[],"mappings":"AAMA;;;EAAA;AASA;EACE,eAAA;EACA,aAAA;ACTF;ADUE;EAHF;IAII,iBAAA;ECPF;AACF;;ADSA;EACE,iBAAA;EACA,aAAA;ACNF;ADOE;EAHF;IAII,iBAAA;ECJF;AACF;;AAEA;EACE,WAAA;EACA,yBCnBO;EDoBP,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;AACF;AAAE;EACE,cAAA;AAEJ;AAAE;EACE,WAAA;EACA,yBC/BK;EDOP,aAAA;EACA,sBAAA;EAyBE,uBAAA;EACA,mBAAA;EACA,SAAA;AAGJ;AADI;EACE,WAAA;EACA,mBAAA;AAGN;AAAI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;EACA,aAAA;EACA,SAAA;AAEN;AADM;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAGR;AAFQ;EACE,yBAAA;EACA,aAAA;EACA,SAAA;AAIV;AAHU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAKZ;AAHU;EACE,iBAAA;EACA,cCzEH;AD8ET;AAHU;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAKZ;AAJY;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAMd;AAHc;EACE,yBAAA;AAKhB;AACQ;EACE,yBAAA;EACA,kBAAA;AACV;AAAU;EACE,UAAA;EACA,qBAAA;EACA,cCxGH;EDyGG,qBAAA;AAEZ;AAEQ;EACE,UAAA;EACA,kBAAA;AAAV;AAEQ;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAAV;AACU;EACE,yBAAA;AACZ;AAGQ;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AADV;AAEU;EACE,yBAAA;AAAZ;AAGQ;EACE,eAAA;AADV;AAGQ;EACE,eAAA;AADV;AAGQ;EACE,eAAA;AADV;AAIQ;EACE,WAAA;EACA,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAFV;AAKQ;EACE,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,sBAAA;AAHV;AAOI;EACE,UAAA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AALR;AASI;EACE,UAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAPN;AAaM;EACE,UAAA;EACA,kBAAA;AAXR;AAcM;EACE,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAZR;AAcQ;EACE,WAAA;AAZV;AAcQ;EACE,yBAAA;EACA,kBAAA;AAZV;AAaU;EACE,UAAA;EACA,qBAAA;EACA,cC5MH;ED6MG,qBAAA;AAXZ;AAiBI;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AAfN;AAgBM;EACE,WAAA;EACA,oBAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;AAdR;AAgBQ;EACE,6BAAA;AAdV;AAiBQ;;EAEE,6BAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;AAfV;AAkBQ;EACE,6BAAA;EACA,yBAAA;EACA,aAAA;EACA,SAAA;AAhBV;AAiBU;EACE,eAAA;EACA,aAAA;EACA,mBAAA;AAfZ;AAiBU;EACE,iBAAA;EACA,cC5PH;AD6OT;AAiBU;EACE,kBAAA;EACA,kBAAA;EACA,eAAA;AAfZ;AAgBY;EACE,qBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,sBAAA;AAdd;AAiBc;EACE,yBAAA;AAfhB;AAoBQ;EACE,6BAAA;EACA,8BAAA;EACA,aAAA;EACA,QAAA;AAlBV;AAmBU;EACE,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;EACA,aAAA;EACA,eAAA;AAjBZ;AAoBQ;EACE,6BAAA;EACA,8BAAA;EACA,aAAA;EACA,QAAA;EACA,wBAAA;AAlBV;AAmBU;EACE,UAAA;AAjBZ;AAwBE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAtBJ;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,4BAAA;EACA,2BAAA;EACA,sBAAA;EACA,YAAA;EACA,eAAA;EACA,0BAAA;AAtBJ;AAuBI;EACE,YAAA;AArBN;AAwBE;EACE,iBAAA;EACA,mBC/TM;EDgUN,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,0BAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAtBJ;;AA0BA;EACE;IACE,sBAAA;IACA,yBAAA;EAvBF;EA0BI;IACE,mBAAA;EAxBN;EA0BI;IACE,sBAAA;EAxBN;EA4BI;IACE,sBAAA;EA1BN;AACF;AA+BA;EACE,YAAA;EACA,0BAAA;EACA,kBAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,qCAAA;AA7BF;;AAgCA;EACE;IACE,uBAAA;EA7BF;EAgCA;IACE,yBAAA;EA9BF;AACF;AAiCA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AA/BF;;AAiCA;EACE,kBAAA;EACA,aAAA;AA9BF;;AAgCA;EACE,cC7YO;ED8YP,kBAAA;EACA,SAAA;EACA,QAAA;EACA,eAAA;AA7BF;AA8BE;EANF;IAOI,SAAA;EA3BF;AACF;;AA8BA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,cC7ZO;ED8ZP,eAAA;EACA,eAAA;AA3BF;;AA8BA;EACE;IACE,sBAAA;IACA,uBAAA;EA3BF;EA4BE;IACE,WAAA;EA1BJ;EA4BE;IACE,kBAAA;IACA,WAAA;EA1BJ;EA6BA;IACE,mBAAA;EA3BF;AACF;AA+BA;EAEE;IACE,sBAAA;EA9BF;EAgCA;IACE,2BAAA;IACA,gBAAA;EA9BF;EAgCA;IACE,WAAA;EA9BF;EAgCA;IACD,mBAAA;EA9BC;EAgCA;IACA,WAAA;EA9BA;AACF","sourcesContent":["@import \"./breakpoints\";\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;700;900&display=swap');\n@mixin font-roboto($weight) {\n  font-family: 'Roboto', sans-serif;\n  font-weight: $weight;\n}\n/**\nCase Usage Example:\nh1 { @include font-roboto(400); }\n**/\n\n$font-sm:1.1rem;\n$font-md:1.2rem;\n$font-lg:1.3rem;\n\nh1 {\n  font-size: 2rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.5rem;\n  }\n}\nh2 {\n  font-size: 1.8rem;\n  margin: 5px 0;\n  @media (max-width: $md) {\n    font-size: 1.2rem;\n  }\n}\n","@import \"../../../../css/colors.scss\";\n@import \"../../../../css/breakpoints.scss\";\n@import \"../../../../css/fonts.scss\";\n\n@mixin flex-row {\n  display: flex;\n  flex-direction: row;\n}\n@mixin flex-row-center {\n  display: flex;\n  justify-content: center;\n  flex-direction: row;\n  align-items: center;\n}\n@mixin flex-col {\n  display: flex;\n  flex-direction: column;\n}\n@mixin flex-col-center {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n}\n\n.edit-profile-container {\n  width: 100%;\n  background-color: $color9;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  padding: 0 50px 50px 50px;\n  h1 {\n    margin: 25px 0;\n  }\n  .edit-profile-wrapper {\n    width: 100%;\n    background-color: $color9;\n    @include flex-col;\n    justify-content: center;\n    align-items: center;\n    gap: 25px;\n\n    .edit-profile-options {\n      width: 80vw;\n      margin-bottom: 25px;\n    }\n\n    .profile-info-section {\n      width: 60vw;\n      display: flex;\n      box-sizing: border-box;\n      background-color: white;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: center;\n      padding: 20px;\n      gap: 15px;    \n      .profile-info-input {\n        width: 80%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        position: relative;\n        .radio-buttons-wrapper {\n          justify-content: flex-end;\n          display: flex;\n          gap: 25px;\n          label {\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n          }\n          span {\n            margin-left: 35px;\n            color: $color6;\n          }\n          input[type=\"radio\"] {\n            visibility: hidden;\n            position: absolute;\n            cursor: pointer;\n            &:before {\n              display: inline-block;\n              content: \" \";\n              width: 20px;\n              height: 20px;\n              border-radius: 50%;\n              border: 2px solid $color6;\n              visibility: initial;\n              margin-top: -5px;\n              box-sizing: border-box;\n            }\n            &:checked {\n              &:before {\n                border: 7px solid $color15;\n              }\n            }\n          }\n        }\n\n        .work-doc-download-btn {\n          border: 1px solid $color5;\n          border-radius: 3px;\n          .work-doc-upload {\n            width: 40%;\n            word-break: break-all;\n            color: $color6;\n            text-decoration: none;\n          }\n        }\n\n        label {\n          width: 70%;\n          margin-right: 10px;\n        }\n        input {\n          width: 100%;\n          padding: 10px;\n          display: inline-block;\n          border: 1px solid $color6;\n          border-radius: 4px;\n          box-sizing: border-box;\n          &:focus {\n            border: 2px solid #4d90fe;\n          }\n        }\n\n        textarea {\n          width: 100%;\n          padding: 10px;\n          display: inline-block;\n          border: 1px solid $color6;\n          border-radius: 4px;\n          box-sizing: border-box;\n          &:focus {\n            border: 2px solid #4d90fe;\n          }\n        }\n        input[type=\"date\"]::-webkit-calendar-picker-indicator {\n          cursor: pointer;\n        }\n        input[type=\"datetime-local\"]::-webkit-calendar-picker-indicator {\n          cursor: pointer;\n        }\n        input[type=\"time\"]::-webkit-calendar-picker-indicator {\n          cursor: pointer;\n        }\n\n        select {\n          width: 100%;\n          padding: 10px;\n          display: inline-block;\n          border: 1px solid $color6;\n          border-radius: 4px;\n          box-sizing: border-box;\n        }\n\n        .basic-multi-select {\n          width: 100%;\n          border: 1px solid $color6;\n          border-radius: 4px;\n          box-sizing: border-box;\n        }\n      }\n    }\n    .edit-services-wrap{\n      width: 80%;\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: center;\n        position: relative;\n\n    }\n\n    .file-info-input {\n      width: 80%;\n      display: flex;\n      flex-direction: row;\n      justify-content: flex-start;\n      align-items: center;\n      // position: relative;\n\n      .file-info-label {\n      }\n\n      label {\n        width: 70%;\n        margin-right: 10px;\n      }\n\n      .file-info-view-wrap {\n        display: flex;\n        flex-direction: row;\n        justify-content: flex-end;\n        align-items: center;\n\n        input {\n          width: 100%;\n        }\n        .work-doc-download-btn {\n          border: 1px solid $color5;\n          border-radius: 3px;\n          .work-doc-upload {\n            width: 40%;\n            word-break: break-all;\n            color: $color6;\n            text-decoration: none;\n          }\n        }\n      }\n    }\n\n    .other-info-section {\n      width: 60vw;\n      display: flex;\n      box-sizing: border-box;\n      background-color: white;\n      flex-direction: column;\n      justify-content: flex-start;\n      align-items: center;\n      .input-wrapper {\n        width: 100%;\n        display: inline-flex;\n        align-items: center;\n        position: relative;\n        padding: 20px;\n\n        .input-section-label {\n          width: -webkit-fill-available;\n        }\n\n        input[type=\"text\"],\n        input[type=\"number\"] {\n          width: -webkit-fill-available;\n          height: 50px;\n          background-color: #f8f7f7;\n          border: 1px solid $color8;\n          box-sizing: border-box;\n          padding: 15px;\n        }\n       \n        .radio-buttons-wrapper {\n          width: -webkit-fill-available;\n          justify-content: flex-end;\n          display: flex;\n          gap:25px;\n          label {\n            cursor: pointer;\n            display: flex;\n            align-items: center;\n          }\n          span {\n            margin-left: 35px;\n            color: $color6;\n          }\n          input[type=\"radio\"] {\n            visibility: hidden;\n            position: absolute;\n            cursor: pointer;\n            &:before {\n              display: inline-block;\n              content: \" \";\n              width: 20px;\n              height: 20px;\n              border-radius: 50%;\n              border: 2px solid $color6;\n              visibility: initial;\n              margin-top: -5px;\n              box-sizing: border-box;\n            }\n            &:checked {\n              &:before {\n                border: 7px solid $color15;\n              }\n            }\n          }\n        }\n        .select-wrapper {\n          width: -webkit-fill-available;\n          justify-content: space-between;\n          display: flex;\n          gap: 5px;\n          select {\n            height: 50px;\n            background-color: #f8f7f7;\n            border: 1px solid $color8;\n            box-sizing: border-box;\n            padding: 10px;\n            cursor: pointer;\n          }\n        }\n        .dates-wrapper {\n          width: -webkit-fill-available;\n          justify-content: space-between;\n          display: flex;\n          gap: 5px;\n          width: calc(100% - 15px);\n          input {\n            width: 33%;\n          }\n        }\n      }\n    }\n  }\n\n  .avatar-label-wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n  }\n  .avatar-label{\n    display: flex;\n    flex-direction: row;\n    width: 150px !important;\n    height: 150px !important;\n    border: 1px solid $color15;\n    border-radius: 50%;\n    background-repeat: no-repeat;\n    background-position: center;\n    background-size: cover;\n    float: right;\n    cursor: pointer;\n    margin-right: 0 !important;\n    &:hover {\n      opacity: 0.8;\n    }\n  }\n  .btn {\n    font-size: 0.8rem;\n    background: $color15;\n    padding: 5px 10px;\n    border-radius: 15px;\n    color: white;\n    margin-top: 10px;\n    margin-right: 0 !important;\n    width: 100% !important;\n    display: flex;\n    justify-content: center;\n    gap: 5px;\n    cursor: pointer;\n  }\n}\n\n@media (max-width: $lg) {\n  .edit-profile-container {\n    flex-direction: column;\n    padding: 0 20px 50px 20px;\n\n    .edit-profile-wrapper {\n      .edit-profile-options {\n        margin-bottom: 25px;\n      }\n      .profile-info-input {\n        width: 100% !important;\n        .questionnaire-section {\n        }\n      }\n      .profile-info-section {\n        width: 100% !important;\n      }\n    }\n  }\n}\n\n.loader {\n  margin: auto;\n  border: 20px solid #eaf0f6;\n  border-radius: 50%;\n  border-top: 20px solid $color6;\n  width: 100px;\n  height: 100px;\n  animation: spinner 4s linear infinite;\n}\n\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.button-wrap {\n  width: 60vw;\n  display: flex;\n  margin-bottom: 25px;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding:30px 0 0 0 ;\n}\n.submit-button {\n  align-self: center;\n  margin: 5px 0;\n}\n.error-message {\n  color: $color6;\n  position: absolute;\n  top: 40px;\n  right: 0;\n  font-size: 14px;\n  @media (max-width: $sm){\n    top: 80px;\n  }\n}\n\n.toggleBtn {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background: #ffffff;\n  border: none;\n  color: $color6;\n  font-size: 16px;\n  cursor: pointer;\n}\n\n@media (max-width: $md){\n  .edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input{\n    flex-direction: column;\n    align-items: flex-start;\n    .avatar-label-wrapper {\n      width: 100%;\n    }\n    p {\n      text-align: center;\n      width: 100%;\n    }\n  }\n  .edit-profile-container .edit-profile-wrapper .profile-info-section .profile-info-input label{\n    margin-bottom: 10px;\n  }\n\n}\n\n@media (max-width: $sm){\n\n  .edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper{\n    flex-direction: column;\n  }\n  .edit-profile-container .edit-profile-wrapper .other-info-section .input-wrapper .radio-buttons-wrapper{\n    justify-content: flex-start;\n    margin-top: 10px;\n  }\n  .edit-profile-container .edit-profile-wrapper .profile-info-section {\n    width: 90vw;\n  }\n  .edit-services-wrap{\n flex-direction: row; \n  }\n  .button-wrap{\n  width: 100%\n  }\n\n}\n\n","$color1: #e34634;\n$color2: #d02050;\n$color3: #46b1ff;\n$color4: #f5eee7;\n$color5: #baad9e;\n$color6: #aa004f;\n$color7: #bebebe;\n$color8: #d6d6d6;\n$color9: #f8f7f7;\n$color10: #202121;\n$color11: #848484;\n$color12: #aa004f;\n$color13: #37AA1E;\n$color14: #E4E5F1;\n$color15: #CB186B;\n$color16: #FCD3CA;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
